import React, {Component} from 'react';

export const Loader = () => {
    return (
        <div className="cssload-loader">
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
            <div className="cssload-side"></div>
        </div>
    );
}

export const LoadingPage = () => {
    return (
        <tr>
            <td className="text-center" colSpan="6">
                <Loader />
                <div className="fs-s mt-4">Đang tải</div>
            </td>
        </tr>
    )
}

export const Reconnecting = () => {
    return (
        <div className="col-12 col-md-12 text-center" style={{marginTop: "15%"}}>
			<Loader /> 
			<div className="fs-m txtGray pt-5">Đang kết nối</div>
		</div>
    );
}

export const Reloading = () => {
    return (
        <div className="col-12 col-md-12 text-center" style={{marginTop: "15%"}}>
			<Loader /> 
			<div className="fs-m txtGray pt-5">Đang lấy dữ liệu</div>
		</div>
    );
}